module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-247.93d4efa.woff2";